module.exports = __webpack_public_path__ + "img/login-image-mobile.5b99ec33.jpg";